import { render, staticRenderFns } from "./branded-caller-id-tab.vue?vue&type=template&id=5523fe1a&scoped=true"
import script from "./branded-caller-id-tab.vue?vue&type=script&lang=js"
export * from "./branded-caller-id-tab.vue?vue&type=script&lang=js"
import style0 from "./branded-caller-id-tab.vue?vue&type=style&index=0&id=5523fe1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523fe1a",
  null
  
)

export default component.exports